// import Style from '../../../../../component/popup/style.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'

const UpdateInvoicePopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, Style, invoiceId }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });


    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const validationSchema = yup.object().shape({
        invoice_path: yup.string().required('This Field is required')
    });

    const formik = useFormik({
        initialValues: {
            invoice_path: "",
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {

            const apiData = JSON.stringify({
                "invoice_id": invoiceId,
                "proof_path": values.invoice_path
            });

            try {
                const resp = await apiCall({ method: "post", url: `pay-water-tanker-invoice`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>

                        <FeildWraper width='100%'>
                            <FormLabel required>Bill Receipt</FormLabel>

                            <FileUploadProgressBar
                                value={formik.values.invoice_path}
                                onChange={(file) => formik.setFieldValue("invoice_path", file)}
                                loader={formik.values.invoice_path}
                            // acceptType="pdf"
                            />
                            {
                                (formik.touched.invoice_path && Boolean(formik.errors.invoice_path)) && (
                                    <FeildError>{formik.touched.invoice_path && formik.errors.invoice_path}</FeildError>
                                )
                            }
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    {/* <div className={`${Style.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default UpdateInvoicePopup
